// App modules
require('./modules/bugsnag.js');
require('./modules/vue.js');
require('./modules/frontend-menu.js');
require('./modules/tooltips.js');
require('./modules/url.js');
require('./modules/charts.js');
require('./modules/lazy-images.js');
require('./modules/lazy-carousel-iframes.js');
require('./modules/empty-links.js');
require('./modules/horizontal-table.js');
require('./modules/lightbox.js');
require('./modules/maps.js');
require('./modules/maps-strava.js');
require('./modules/ajax.js');
require('./modules/carousel.js');
require('./modules/easy-challenge.js');